export default {
  bind(_, binding, vnode) {
    vnode.context.$nextTick(() => {
      binding.value()
    })
  },
}
